import { Banner } from './components/Banners/Banner';
import Header from './components/Header';
import NavToast from './components/Toast/NavToast';

const GlobalNavContent = () => (
  <>
    <Banner />
    <Header />
    <NavToast loggedIn />
  </>
);

export default GlobalNavContent;
